module.exports = __webpack_public_path__ + "static/img/revenue-top2.9c1ac9ed.png";